import React from 'react';

export const inr = (n) => `${Number(n) < 0 ? '−' : ''}₹${Math.abs(Number(n || 0)).toLocaleString('en-IN', { maximumFractionDigits: 0 })}`;

// Step-by-step: revenue down to estimated net profit.
export default function ProfitWaterfall({ t }) {
  const steps = [
    { label: 'Revenue (pre-GST)', value: t.revenue, kind: 'base' },
    { label: '+ Transport charged', value: t.transport, kind: 'add' },
    { label: '− COGS', value: -t.cogs, kind: 'sub' },
    { label: '− Freight', value: -t.freight, kind: 'sub' },
    { label: '− Installation & warranty', value: -t.installation, kind: 'sub' },
    { label: '− Sales commission', value: -t.commission, kind: 'sub' },
    { label: '= Contribution', value: t.contribution, kind: 'total' },
    { label: '− Salespeople salaries', value: -t.own_salary, kind: 'sub' },
    { label: '− Other staff & office costs', value: -t.shared_costs, kind: 'sub' },
    { label: '= Estimated net profit', value: t.net_profit, kind: 'final' },
  ];
  const max = Math.max(...steps.map((s) => Math.abs(s.value)), 1);
  return (
    <div className="medical-card p-5" data-testid="profit-waterfall">
      <div className="space-y-2">
        {steps.map((s) => (
          <div key={s.label} className={`grid grid-cols-[200px_1fr_120px] items-center gap-3 ${s.kind === 'total' || s.kind === 'final' ? 'pt-2 border-t border-[#D5E8E4]' : ''}`}>
            <span className={`text-sm ${s.kind === 'final' || s.kind === 'total' ? 'font-bold text-[#052A23]' : 'text-[#3B5A54]'}`}>{s.label}</span>
            <div className="h-3 rounded-full bg-[#F4F9F7] overflow-hidden">
              <div className={`h-full rounded-full transition-[width] duration-500 ${s.kind === 'sub' ? 'bg-rose-300' : s.value < 0 ? 'bg-rose-500' : s.kind === 'final' ? 'bg-[#00a69c]' : 'bg-[#7FD3CC]'}`}
                style={{ width: `${(Math.abs(s.value) / max) * 100}%` }} />
            </div>
            <span className={`text-sm text-right tabular-nums ${s.value < 0 && s.kind !== 'sub' ? 'text-rose-700 font-bold' : s.kind === 'final' ? 'text-[#00857e] font-bold' : 'text-[#052A23]'}`}
              data-testid={`waterfall-${s.label.replace(/[^a-z]+/gi, '-').toLowerCase()}`}>{inr(s.value)}</span>
          </div>
        ))}
      </div>
      <p className="text-xs text-[#6D8E87] mt-3">
        Net margin <b data-testid="profit-net-margin">{t.net_margin_pct == null ? '—' : `${t.net_margin_pct}%`}</b> · GM {t.gm_pct == null ? '—' : `${t.gm_pct}%`} · {t.orders} won order{t.orders === 1 ? '' : 's'}
      </p>
    </div>
  );
}
